import Vue from 'vue' // 引入vue实例
import VueI18n from 'vue-i18n' // 引入vue-i18n多语言包

// 引入element ui自带语言包
import ElementUILocale from 'element-ui/lib/locale' 
import enLocale from 'element-ui/lib/locale/lang/en' 
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const UIlocales = {
    zh: zhLocale,
    en: enLocale
}

Vue.use(VueI18n) // vue使用vue-i18n

const locales = { // 引入zh.json以及en.json
    zh: require('./zh.json'),
    en: require('./en.json')
}

const i18n = new VueI18n({ // 创建带有选项的 VueI18n 实例
    locale: 'zh', // 语言标识，在这里默认为en,即为英文
    messages : locales // 语言包，上边创建的json文件
})

// 通过判断lang语言标志符来return先对应的语言
const setUIlocales = lang =>{
    switch (lang) {
      case 'zh': return UIlocales.zh
      case 'en': return UIlocales.en
    }
}

Vue.config.lang = 'zh'
i18n.locale = 'zh'
ElementUILocale.use(setUIlocales('zh'));

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js